import getHiddenElementDimensions from './get-hidden-element-dimensions.js';
import getViewport from './get-viewport.js';
import getWindowScrollLeft from './get-window-scroll-left.js';
import getWindowScrollTop from './get-window-scroll-top.js';

export default function absolutePosition (element, target) {
  if (element) {
    const elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : getHiddenElementDimensions(element);
    const elementOuterHeight = elementDimensions.height;
    const elementOuterWidth = elementDimensions.width;
    const targetOuterHeight = target.offsetHeight;
    const targetOuterWidth = target.offsetWidth;
    const targetOffset = target.getBoundingClientRect();
    const windowScrollTop = getWindowScrollTop();
    const windowScrollLeft = getWindowScrollLeft();
    const viewport = getViewport();
    let top,
      left,
      origin = 'top';

    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
      top = targetOffset.top + windowScrollTop - elementOuterHeight;
      origin = 'bottom';

      if (top < 0) {
          top = windowScrollTop;
      }
    } else {
      top = targetOuterHeight + targetOffset.top + windowScrollTop;
    }

    if (targetOffset.left + elementOuterWidth > viewport.width) left = Math.max(0, targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth);
    else left = targetOffset.left + windowScrollLeft;

    element.style.top = top + 'px';
    element.style.insetInlineStart = left + 'px';
    element.style.transformOrigin = origin;
    element.style.marginTop = origin === 'bottom' ? `calc(${'2px'} * -1)` : '';
  }
}
